module.exports = {"620122100":"石洞镇","620122102":"忠和镇","620122103":"什川镇","620122104":"九合镇","620122105":"水阜镇","620122106":"黑石镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620122.json
// module id = 2685
// module chunks = 0